import axiosInstance from '../../utils/axios';

export interface DocsCatalog {
  id: number;
  name: string;
  prefix: string;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
}

// Hàm lấy danh sách loại văn bản từ API
export const fetchDocsCatalogs = async (): Promise<DocsCatalog[]> => {
  try {
    // Kiểm tra dữ liệu trong localStorage trước
    const cachedData = localStorage.getItem('pmis_docs_catalogs');
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      if (parsedData && parsedData.code === 0 && parsedData.data?.records) {
        return parsedData.data.records;
      }
    }

    // Nếu không có trong localStorage hoặc dữ liệu không hợp lệ, gọi API
    const response = await axiosInstance.get('/docs-catalogs', {
      params: {
        page_size: -1 // Lấy tất cả
      }
    });
    if (response.data.code === 0) {
      // Lưu vào localStorage
      localStorage.setItem('pmis_docs_catalogs', JSON.stringify(response.data));
      return response.data.data.records;
    }
    throw new Error(response.data.message || 'Có lỗi xảy ra khi tải danh sách loại văn bản');
  } catch (error) {

    throw error;
  }
};

export const DOCUMENT_TYPES = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
  INTERNAL: 'INTERNAL'
} as const;

export const PRIORITY_LEVELS = [
  { value: 'Thường', label: 'Thường' },
  { value: 'Khẩn', label: 'Khẩn' },
  { value: 'Hỏa tốc', label: 'Hỏa tốc' }
];

export const SECURITY_LEVELS = [
  { value: 'Thường', label: 'Thường' },
  { value: 'Mật', label: 'Mật' },
  { value: 'Tối mật', label: 'Tối mật' }
]; 